function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M30.433 341.454C-12.81-62.218 593.777-66.792 658.583 275.752c41.866 188.28-80.076 370.721-246.494 438.626C220.953 734.372 59.747 523.751 30.433 341.454z",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

function Svg004(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 696 744",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjk2IDc0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMC40MzMgMzQxLjQ1NEMtMTIuODEtNjIuMjE4IDU5My43NzctNjYuNzkyIDY1OC41ODMgMjc1Ljc1MmM0MS44NjYgMTg4LjI4LTgwLjA3NiAzNzAuNzIxLTI0Ni40OTQgNDM4LjYyNkMyMjAuOTUzIDczNC4zNzIgNTkuNzQ3IDUyMy43NTEgMzAuNDMzIDM0MS40NTR6IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+Cjwvc3ZnPg==";
export { Svg004 as ReactComponent };